// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/attachments/attachments.component.scss
// module id = 201
// module chunks = 0